import React from "react";
import { motion } from "framer-motion";
import "../css/ProductCardComponent.css";
import { useNavigate } from "react-router-dom";

import VioletRibbon from "../assets/violet-ribbon.png";
import PinkRibbon from "../assets/pink-ribbon.png";
import YellowRibbon from "../assets/yellow-ribbon.png";

const ProductCardComponent = ({
  shopId,
  productId,
  label,
  image,
  name,
  price, // Real price
  quantity,
  actualprice, // Original price
  discount_percentage,
  onDelete,
  onEdit,
}) => {
  const navigate = useNavigate();

  const handleCardClick = (e) => {
    if (
      e.target.closest(".product-delete-btn") ||
      e.target.closest(".product-edit-btn")
    )
      return;
    navigate(`/product-details/${shopId}/${productId}`);
  };

  const productImageUrl = image || "/default-product.png";

  // --- Ribbon Logic ---
  let finalRibbonImage = null;
  let finalLabel = null;
  const normalizedLabel = label?.trim().toLowerCase();
  const discount = Number(discount_percentage);
  const hasDiscount = discount > 0;

  if (normalizedLabel === "popular") {
    finalRibbonImage = VioletRibbon;
    finalLabel = "Popular";
  } else if (normalizedLabel === "steal_deal") {
    finalRibbonImage = PinkRibbon;
    finalLabel = "Steal Deals";
  } else if (hasDiscount) {
    finalRibbonImage = YellowRibbon;
    finalLabel = `${discount}% OFF`;
  }

  // --- Price Display Logic ---
  const numericActualPrice = Number(actualprice) || 0;
  const numericPrice = Number(price) || 0;

  const showOnlyRealPrice =
    normalizedLabel === "popular" || normalizedLabel === "steal_deal";
  const showOldPrice =
    !showOnlyRealPrice && (numericActualPrice > numericPrice || !label);

  return (
    <motion.div
      className="product-card"
      onClick={handleCardClick}
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ type: "spring", stiffness: 120, damping: 15 }}
      whileHover={{ scale: 1.05, boxShadow: "0 8px 20px rgba(0,0,0,0.15)" }}
    >
      {/* Ribbon */}
      {finalRibbonImage && (
        <motion.div
          className="product-ribbon"
          initial={{ y: -10, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          <img src={finalRibbonImage} alt={finalLabel} className="ribbon-img" />
          <span className="ribbon-label">{finalLabel}</span>
        </motion.div>
      )}

      {/* Delete Button */}
      <motion.div
        className="product-delete-btn"
        onClick={(e) => {
          e.stopPropagation();
          onDelete();
        }}
        whileTap={{ scale: 0.8, rotate: -20 }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
        >
          <path
            fill="#FF3D00"
            d="M7 21q-.825 0-1.412-.587T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 
             .825-.587 1.413T17 21zm2-4h2V8H9zm4 
             0h2V8h-2z"
          />
        </svg>
      </motion.div>

      {/* Product Image */}
      <motion.img
        src={productImageUrl}
        alt={name || "Product"}
        className="product-image"
        initial={{ scale: 0.95 }}
        animate={{ scale: 1 }}
        transition={{ delay: 0.1 }}
      />

      {/* Product Name */}
      <p className="product-name-paw">{name || "Unnamed Product"}</p>

      {/* Price Section */}
      <div className="product-price">
        <span className="new-price">₹{numericPrice}</span>
        {showOldPrice && numericActualPrice > numericPrice && (
          <span className="old-price">₹{numericActualPrice}</span>
        )}
      </div>

      {/* Edit Button */}
      <motion.button
        className="product-edit-btn"
        onClick={(e) => {
          e.stopPropagation();
          navigate("/add-product", {
            state: {
              shopId,
              productId,
              name,
              price,
              actualprice,
              quantity: quantity ?? "",
              discount_percentage,
              image: productImageUrl,
              label,
            },
          });
        }}
        whileHover={{ scale: 1.1, backgroundColor: "#555" }}
        whileTap={{ scale: 0.9 }}
      >
        Edit
      </motion.button>
    </motion.div>
  );
};

export default ProductCardComponent;
